module.exports = {"310109009":"欧阳路街道","310109010":"曲阳路街道","310109011":"广中路街道","310109014":"嘉兴路街道","310109016":"凉城新村街道","310109017":"四川北路街道","310109018":"北外滩街道","310109019":"江湾镇街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310109.json
// module id = 815
// module chunks = 0